/**
 * Component - employeeList
 */

export const employeeList = ():void => {
  // Run the script for each individual component found on the page
  const componentSelector = document.querySelectorAll('.js-employeeList') as unknown as HTMLElement[]
  componentSelector.forEach((component:HTMLElement) => {

  })
}
